import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { MailingListCommentReply } from './types/mailing-list-comment-reply.type';

/**
 * Retrieves the comments for a specific mailing list.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @param mailingListId - The unique identifier of the mailing list for which to fetch comments.
 * @returns A promise that resolves to an {@link OperationResultWithData} containing an array
 * of {@link MailingListCommentReply} objects.
 * @throws Will throw an error if the request fails.
 */
export const getMailingListComments = async (instance: KyInstance, mailingListId: number) => {
  try {
    return await instance
      .get<OperationResultWithData<MailingListCommentReply[]>>(
        formatString(Uri.mailingList.getComments, mailingListId.toString())
      )
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
